import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './migrations.css';

class Migrations extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			appStuff: 'Do migrations here'
		};
	}

	render() {
		return <div className="migrations-view animated fadeIn">{this.data.appStuff}</div>;
	}
}

export default Migrations;



// WEBPACK FOOTER //
// ./src/views/migrations/Migrations.js